import { z } from 'zod'

export const MessageSchema = z.object({
  id: z.number(),
  user_id: z.number().nullable(),
  message: z.string(),
  created_datetime: z.string(),
})

export const MessagesSchema = z.array(MessageSchema)

export type Message = z.infer<typeof MessageSchema>
